import type {
  AuditFindingReportSubtype,
  AuditFindingReportType,
  ClaimReportTransferInput,
  PreflightReportTransferInput,
  preflightReportTransferQuery,
  sendClaimReportsToClientMutation,
  versionReportMutation,
} from "../../remote/gql/graphql";
import type { ClientReturnType } from "../types";
import type { AlaffiaClientModuleArgs } from "./modules";

import { sendClaimReportsToClientMutationDoc } from "../../remote/mutations/sendClaimReportsToClient.gql";
import { versionReportMutationDoc } from "../../remote/mutations/versionReport.gql";
import { getReportTransfersQueryDoc } from "../../remote/queries/getReportTransfers.gql";
import { preflightReportTransferQueryDoc } from "../../remote/queries/preflightReportTransfer.gql";
import { AlaffiaClientModule } from "./modules";

type ReportsModuleArgs = AlaffiaClientModuleArgs;

export class ReportsModule extends AlaffiaClientModule {
  constructor(args: ReportsModuleArgs) {
    super(args);
  }

  getAllTransfers = async () => {
    const result = await this.runGqlQuery(
      getReportTransfersQueryDoc,
      {},
      "getAllTransfers",
    );

    return {
      data: result.data?.reportTransfers ?? null,
      error: result.error ?? null,
    };
  };

  preflightReportTransfer = async (input: {
    input: PreflightReportTransferInput;
  }): ClientReturnType<
    preflightReportTransferQuery["preflightReportTransfer"]
  > => {
    const result = await this.runGqlQuery(
      preflightReportTransferQueryDoc,
      {
        input: input?.input ?? {},
      },
      "preflightReportTransfer",
    );

    return {
      data: result.data?.preflightReportTransfer ?? null,
      error: result.error ?? null,
    };
  };

  sendClaimReportsToClient = async (input: {
    input: ClaimReportTransferInput;
  }): ClientReturnType<
    sendClaimReportsToClientMutation["sendClaimReportsToClient"]
  > => {
    const result = await this.runGqlMutation(
      sendClaimReportsToClientMutationDoc,
      {
        input: input?.input ?? {},
      },
      "sendClaimReportsToClient",
    );

    return {
      data: result.data?.sendClaimReportsToClient ?? null,
      error: result.error ?? null,
    };
  };

  versionReport = async (input: {
    reportId: string;
    reportSubtype: AuditFindingReportSubtype;
    reportType: AuditFindingReportType;
  }): ClientReturnType<versionReportMutation["versionReport"]> => {
    const result = await this.runGqlMutation(
      versionReportMutationDoc,
      {
        reportId: input.reportId,
        reportSubtype: input.reportSubtype,
        reportType: input.reportType,
      },
      "versionReport",
    );

    return {
      data: result.data?.versionReport ?? null,
      error: result.error ?? null,
    };
  };
}
